var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from "react";
export function withProviders(Component) {
  var providers = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    providers[_i - 1] = arguments[_i];
  }
  return function (props) {
    return providers.reduce(function (acc, Provider) {
      return React.createElement(Provider, null, acc);
    }, React.createElement(Component, __assign({}, props)));
  };
}
;